import React from 'react';
import { WithTranslation, withTranslation } from 'react-i18next';
import styled from 'styled-components/macro';

import { Session, Transaction } from '../../types/checkout';
import { distances, border, colors } from '../../styles/constants';
import { H2, P } from '../../components/Typography';
import { Dl, Dt, Dd } from '../../components/DescriptionList/Horizontal';
import { PhoneNumber } from '../../components/Formatters';
import Hr from '../../components/Hr';
export interface CustomerInfoProps extends WithTranslation {
    transaction?: Transaction;
    session?: Session;
}

const CustomerInfo = (
    {
        t,
        transaction,
        session,
    }: CustomerInfoProps
) => {
    const hasSessionCustomer = session && session.customer && (session.customer.email || session.customer.phone_number);
    const hasTransactionCustomer =
        transaction && transaction.customer && (transaction.customer.email || transaction.customer.phone_number);
    const hasCustomerData = hasSessionCustomer || hasTransactionCustomer;

    const sessionEmail = session && session.customer && session.customer.email;
    const transactionEmail = transaction && transaction.customer && transaction.customer.email;
    const hasEmail = sessionEmail || transactionEmail;

    const sessionPhoneNumber = session && session.customer && session.customer.phone_number;
    const transactionPhoneNumber = transaction && transaction.customer && transaction.customer.phone_number;
    const hasPhoneNumber = sessionPhoneNumber || transactionPhoneNumber;
    return (
        <Wrapper>
            <H2>{t('payments.transaction.customer_info')}</H2>
            <Hr />

            {!hasCustomerData && <P>{t(transaction ? 'payments.transaction.no_customer_info' : 'payments.session.no_customer_info')}</P>}

            {hasEmail && (
                <>
                    <Dl>
                        <Dt doubleColumn>{t('payments.fields.email')} </Dt>
                        <Dd title={hasEmail}>
                            {hasEmail}
                            {sessionEmail && transactionEmail && sessionEmail !== transactionEmail && (
                                <> {t('payments.fields.origin.session')}</>
                            )}
                        </Dd>
                    </Dl>
                    {sessionEmail && transactionEmail && sessionEmail !== transactionEmail && (
                        <Dl>
                            <Dt doubleColumn>{t('payments.fields.email')}</Dt>
                            <Dd title={transactionEmail}>
                                {transactionEmail}
                                {sessionEmail && transactionEmail && sessionEmail !== transactionEmail && (
                                    <> {t('payments.fields.origin.transaction')}</>
                                )}
                            </Dd>
                        </Dl>
                    )}
                </>
            )}
            {hasPhoneNumber && (
                <>
                    <Dl>
                        <Dt doubleColumn>{t('payments.fields.phone_number')}</Dt>
                        <Dd>
                            <PhoneNumber phoneNumber={hasPhoneNumber} />
                            {sessionPhoneNumber &&
                                transactionPhoneNumber &&
                                sessionPhoneNumber !== transactionPhoneNumber && (
                                <> {t('payments.fields.origin.session')}</>
                            )}
                        </Dd>
                    </Dl>
                    {sessionPhoneNumber && transactionPhoneNumber && sessionPhoneNumber !== transactionPhoneNumber && (
                        <Dl>
                            <Dt doubleColumn>{t('payments.fields.phone_number')}</Dt>
                            <PhoneNumber phoneNumber={transactionPhoneNumber} />
                            {sessionPhoneNumber &&
                                transactionPhoneNumber &&
                                sessionPhoneNumber !== transactionPhoneNumber && (
                                <> {t('payments.fields.origin.transaction')}</>
                            )}
                        </Dl>
                    )}
                </>
            )}
        </Wrapper>
    );
};

export default withTranslation()(CustomerInfo);

const Wrapper = styled.div`
    padding-top: ${distances.normal};
`;
